import {createApi} from "@reduxjs/toolkit/query/react"
import baseQuery from "../../utils/apiIIKOConfig"
import {IBasicResponse} from "../../types/api"
import {
    IReviewCategory,
    IReviewCategoryCreateParams,
    IReviewCategoryCreateResponse,
    IReviewCategoryDeleteParams, IReviewCategoryUpdateParams, IReviewCategoryUpdateTagsParams
} from "./ReviewCategoryApiTypes"

export const reviewCategoryApi = createApi({
    reducerPath: "reviewCategoryApi",
    baseQuery,
    tagTypes: ["review-categories"],
    endpoints: build => ({
        getReviewCategories: build.query<IBasicResponse<IReviewCategory[]>, void>({
            query: () => ({
                method: "GET",
                url: `v1/review-categories/list`,
            }),
            providesTags: ["review-categories"]
        }),
        createReviewCategory: build.mutation<IBasicResponse<IReviewCategoryCreateResponse>, IReviewCategoryCreateParams>({
            query: (body) => ({
                method: "POST",
                url: `v1/review-categories`,
                body
            }),
            invalidatesTags: ["review-categories"]
        }),
        deleteReviewCategory: build.mutation<IBasicResponse<void>, IReviewCategoryDeleteParams>({
            query: ({id}) => ({
                method: "DELETE",
                url: `v1/review-categories/${id}`,
            }),
            invalidatesTags: ["review-categories"]
        }),
        updateReviewCategory: build.mutation<IBasicResponse<void>, IReviewCategoryUpdateParams>({
            query: ({id, ...body}) => ({
                method: "PATCH",
                url: `v1/review-categories/${id}`,
                body
            }),
            invalidatesTags: ["review-categories"]
        }),
        updateReviewCategoryTag: build.mutation<IBasicResponse<void>, IReviewCategoryUpdateTagsParams>({
            query: ({id, ...body}) => ({
                method: "PATCH",
                url: `v1/review-categories/${id}/tags`,
                body
            }),
            invalidatesTags: ["review-categories"]
        })
    })
})

export const {
    useGetReviewCategoriesQuery,
    useCreateReviewCategoryMutation,
    useDeleteReviewCategoryMutation,
    useUpdateReviewCategoryMutation,
    useUpdateReviewCategoryTagMutation
} = reviewCategoryApi
